export default __webpack_public_path__ + "static/media/img_parcours_canal_logo.ca8f2720.svg";